// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + {"0":"e8dec7efcdc6dc08","957":"e2745835eec2cb6b","1738":"1bd95b5a858d1212","3933":"61b4c9334f43ec3a","6325":"72b2ee40f9982890"}[chunkId] + ".css";
};